<template>
  <div>
    <!-- begin login-cover -->
    <div class="login-cover">
      <div
        class="login-cover-image"
        v-bind:style="{
          backgroundImage:
            'url(' + require('@/assets/images/login-bg.png') + ')'
        }"
      ></div>
      <div class="login-cover-bg"></div>
    </div>
    <!-- end login-cover -->

    <!-- begin login -->
    <div class="login login-v2" data-pageload-addclass="animated fadeIn">
      <!-- begin brand -->
      <div class="login-header">
        <div class="brand">
          <span
            ><img
              src="@/assets/images/bonacube-logo-white.png"
              style="max-width: 300px"
          /></span>
        </div>
      </div>
      <!-- end brand -->
      <!-- begin login-content -->
      <div class="login-content">
        <form @submit.prevent="handleSubmit" class="margin-bottom-0">
          <div class="form-group m-b-20">
            <input
              v-model="email"
              type="text"
              class="form-control form-control-lg"
              placeholder="Email address"
              required
            />
            <div class="my-2">
              Instructions for password reset will be sent to given email
            </div>
            <button
              :disabled="!validEmail || submitDisabled"
              type="submit"
              class="btn btn-success btn-block btn-lg"
            >
              Reset password
            </button>
          </div>

          <div v-if="messages.errors && messages.errors.length > 0">
            <b-list-group>
              <b-list-group-item
                variant="warning"
                v-for="(message, messageKey) in messages.errors"
                :key="messageKey"
              >
                {{ message }}
              </b-list-group-item>
            </b-list-group>
          </div>

          <div v-if="messages.success && messages.success.length > 0">
            <b-list-group>
              <b-list-group-item
                variant="success"
                v-for="(message, messageKey) in messages.success"
                :key="messageKey"
              >
                {{ message }}
              </b-list-group-item>
            </b-list-group>
          </div>
        </form>
      </div>
      <!-- end login-content -->
    </div>
    <!-- end login -->
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import PageOptions from '../config/PageOptions.vue'
export default {
  created() {
    PageOptions.pageEmpty = true
  },
  beforeRouteLeave(to, from, next) {
    PageOptions.pageEmpty = false
    next()
  },
  data: () => ({
    email: null,
    messages: {
      success: [],
      errors: []
    },
    submitDisabled: null
  }),
  computed: {
    validEmail() {
      return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        this.email
      )
    }
  },
  methods: {
    ...mapActions('auth', ['requestPasswordReset']),
    handleSubmit() {
      this.submitDisabled = true
      this.messages = {
        success: [],
        errors: []
      }

      const email = this.email
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, source: window.location.origin })
      }
      fetch(process.env.VUE_APP_API_URL + '/auth/forgot', requestOptions)
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            this.messages.success.push(data.message)
          } else {
            this.messages.errors.push(data.message)
            this.submitDisabled = false
          }
        })
    }
  }
}
</script>
